module.exports = __webpack_public_path__ + "img/1557614100250435585.bd2c4a30.png";